import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=0b57cd5f&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b57cd5f')) {
      api.createRecord('0b57cd5f', component.options)
    } else {
      api.reload('0b57cd5f', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=0b57cd5f&", function () {
      api.rerender('0b57cd5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/footer.vue"
export default component.exports